import React, { Component } from "react";
import EtiquetaConfirmador from '../../../../Common/Components/EtiquetaConfirmador';

class TableRow extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * 
     * @param {any} vencimiento Parametro string, representa la fecha de vencimiento de la tarjeta. Formato YYYYMM
     */
    formatearVencimiento(vencimiento) {
        return ((vencimiento) ? vencimiento.substring(6, 4) + "/" + vencimiento.substring(0, 4) : "");
    }

    /**
     * Arma la descripcion del limite de compra para la tarjeta
     * @param {any} porcentajeLimiteCompra
     * @param {any} modalidadDistribucionLimiteId
     */
    armarDescripcionLimite(porcentajeLimiteCompra, modalidadDistribucionLimiteId, valorCuenta) {
        if (modalidadDistribucionLimiteId == 1) {
            return "SIN LIMITES"
        } else {
            return porcentajeLimiteCompra + "% (" + ((porcentajeLimiteCompra * valorCuenta) / 100) + ")";
        }
    }


    render() {
        /*Atributos*/
        const { tarjeta, filaEnModoEdicion, popupId, mostrarFilaEnModoEdicion, modalidadDistribucionLimiteId, limiteCompraCodigo } = this.props;
        let documentoTipoCodigoVisa = tarjeta.DocumentoTipoCodigoVisa ? tarjeta.DocumentoTipoCodigoVisa + " " : ""

        return (
            <tr key={"table-row-tarjeta-" + tarjeta.TarjetaCreditoId}>

                <td className="default-td"> 
                    {tarjeta.ClienteNombre + " " + tarjeta.ClienteApellido + " (" + documentoTipoCodigoVisa + tarjeta.DocumentoNumero + ")"}</td>

                <td className="default-td">
                    {tarjeta.TarjetaTipoDescripcion}</td>

                <td className="default-td">
                    {this.armarDescripcionLimite(tarjeta.PorcentajeLimiteCompra, modalidadDistribucionLimiteId, tarjeta.CuentaValor)}</td>

                <td className="default-td" colSpan="2">
                    <a className={"clickable none-text-decoration ti-angle-double-" + ((filaEnModoEdicion) ? "up" : "down")}
                        onClick={() => mostrarFilaEnModoEdicion(tarjeta.TarjetaCreditoId, filaEnModoEdicion)}></a></td>
            </tr>
        );
    }
}

export default TableRow;